var map = {
	"./common/reducers": "IuQ2",
	"./dashboard/reducers": "vlJv",
	"./frontpages/reducers": "ginK",
	"./geodata/reducers": "ZdKa",
	"./lives/reducers": "E/Jz",
	"./locales/reducers": "f2NO",
	"./menu/reducers": "kejs",
	"./notifications/reducers": "KSe7",
	"./recaptcha/reducers": "rY9T",
	"./tags/reducers": "UJ4c",
	"./targets/reducers": "y8fU",
	"./taxes/reducers": "nLVr",
	"./tos/reducers": "52ed",
	"./user/reducers": "nGSc",
	"./videos/reducers": "XUwF",
	"./web-push/reducers": "rG6s"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pdTz";